(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fo-grow-steps"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fo-grow-steps')) {
    class FoGrowSteps extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
        this.index = 0;
        this.paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.interval = Number(this.dataset.interval) || 3000;
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index, true));
          tab.addEventListener('keydown', event => this.onKeydown(event, index));
        });
        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          this.addEventListener('pointerenter', () => this.stop());
          this.addEventListener('pointerleave', () => this.start());
        }
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', event => {
          if (!this.contains(event.relatedTarget)) this.start();
        });
        this.handleVisibility = () => {
          if (document.hidden) this.stop();
          else this.start();
        };
        this.handlePageShow = () => this.start();
        this.handlePageHide = () => this.stop();
        document.addEventListener('visibilitychange', this.handleVisibility);
        window.addEventListener('pageshow', this.handlePageShow);
        window.addEventListener('pagehide', this.handlePageHide);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('visibilitychange', this.handleVisibility);
        window.removeEventListener('pageshow', this.handlePageShow);
        window.removeEventListener('pagehide', this.handlePageHide);
      }

      select(index, restart) {
        this.index = (index + this.tabs.length) % this.tabs.length;
        this.tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === this.index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        this.panels.forEach((panel, panelIndex) => {
          const active = panelIndex === this.index;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
        if (restart) {
          this.stop();
          this.start();
        }
      }

      onKeydown(event, index) {
        let next = null;
        if (event.key === 'ArrowRight') next = index + 1;
        if (event.key === 'ArrowLeft') next = index - 1;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (next === null) return;
        event.preventDefault();
        next = (next + this.tabs.length) % this.tabs.length;
        this.select(next, true);
        this.tabs[next].focus();
      }


      start() {
        if (this.paused || this.timer) return;
        this.classList.remove('is-running');
        void this.offsetWidth;
        this.classList.add('is-running');
        this.timer = window.setTimeout(() => {
          this.timer = null;
          this.select(this.index + 1, false);
          this.classList.remove('is-running');
          void this.offsetWidth;
          this.classList.add('is-running');
          this.start();
        }, this.interval);
      }

      stop() {
        window.clearTimeout(this.timer);
        this.timer = null;
        this.classList.remove('is-running');
      }
    }
    customElements.define('fo-grow-steps', FoGrowSteps);
  }

  const initializeFoMobileGrowSteps = () => {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    document.querySelectorAll('fo-grow-steps').forEach((root) => {
      if (root.dataset.mobileRotationReady === 'true') return;

      const tabs = [...root.querySelectorAll('[role="tab"]')];
      const panels = [...root.querySelectorAll('[role="tabpanel"]')];
      if (tabs.length < 2 || tabs.length !== panels.length) return;

      if (typeof root.stop === 'function') root.stop();
      root.paused = true;

      let index = 0;
      let timer = null;
      let inView = false;

      const select = (nextIndex) => {
        index = (nextIndex + panels.length) % panels.length;
        tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel, panelIndex) => {
          const active = panelIndex === index;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
      };

      const stop = () => {
        window.clearTimeout(timer);
        timer = null;
      };

      const schedule = () => {
        stop();
        if (!inView || document.hidden) return;
        timer = window.setTimeout(() => {
          select(index + 1);
          schedule();
        }, 3000);
      };

      tabs.forEach((tab, tabIndex) => {
        tab.addEventListener('click', () => {
          select(tabIndex);
          schedule();
        });
      });

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stop();
        else schedule();
      });

      const observer = new IntersectionObserver((entries) => {
        const entry = entries[0];
        const nextInView = Boolean(entry?.isIntersecting && entry.intersectionRatio >= 0.25);
        if (nextInView === inView) return;
        inView = nextInView;
        if (inView) {
          select(0);
          schedule();
        } else {
          stop();
        }
      }, { threshold: [0, 0.25, 0.5] });

      select(0);
      observer.observe(root);
      root.dataset.mobileRotationReady = 'true';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeFoMobileGrowSteps, { once: true });
  } else {
    initializeFoMobileGrowSteps();
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fo-main-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeQualityRotators = (scope = document) => {
      scope.querySelectorAll('[data-quality-rotator]').forEach((root) => {
        if (root.dataset.qualityInitialized === 'true') return;

        const tabs = Array.from(root.querySelectorAll('[data-quality-tab]'));
        const panels = Array.from(root.querySelectorAll('[data-quality-panel]'));
        let activeIndex = 0;

        const selectPanel = (index, moveFocus = false) => {
          activeIndex = (index + tabs.length) % tabs.length;
          tabs.forEach((tab, tabIndex) => {
            const isActive = tabIndex === activeIndex;
            tab.setAttribute('aria-selected', String(isActive));
            tab.tabIndex = isActive ? 0 : -1;
            panels[tabIndex].hidden = !isActive;
          });
          if (moveFocus) tabs[activeIndex].focus();
        };

        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => selectPanel(index));
          tab.addEventListener('keydown', (event) => {
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            let nextIndex = activeIndex;
            if (event.key === 'ArrowLeft') nextIndex -= 1;
            if (event.key === 'ArrowRight') nextIndex += 1;
            if (event.key === 'Home') nextIndex = 0;
            if (event.key === 'End') nextIndex = tabs.length - 1;
            selectPanel(nextIndex, true);
          });
        });

        root.dataset.qualityInitialized = 'true';
        root.classList.add('is-enhanced');
        selectPanel(0);
      });
    };

    initializeQualityRotators();
    document.addEventListener('shopify:section:load', (event) => initializeQualityRotators(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fo-product-experience"] && !Shopify.designMode) return;
  try {
    
  const secureExternalLinks = (root = document) => {
    root.querySelectorAll?.('a[target="_blank"]').forEach((link) => {
      if (link.origin === window.location.origin) return;
      link.rel = 'noopener noreferrer';
    });
  };

  secureExternalLinks();

  const externalLinkObserver = new MutationObserver((records) => {
    records.forEach((record) => {
      record.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        secureExternalLinks(node);
        if (node.matches?.('a[target="_blank"]') && node.origin !== window.location.origin) {
          node.rel = 'noopener noreferrer';
        }
      });
    });
  });

  externalLinkObserver.observe(document.body, { childList: true, subtree: true });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fo-site-chrome"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const path = window.location.pathname.replace(/\/$/, '');
    let page = '';

    if (path === '/pages/tutorial') page = 'tutorial';
    if (path === '/pages/faq') page = 'faq';
    if (path === '/pages/contact-us') page = 'support';
    if (path.startsWith('/products/')) page = 'product';
    if (path === '/blogs/oyster-mushroom-guides') page = 'guides';
    if (path.startsWith('/blogs/oyster-mushroom-guides/')) page = 'article';

    if (page) document.documentElement.dataset.foPage = page;

    const ensureFormLabels = () => {
      document.querySelectorAll('input:not([type="hidden"]), textarea, select').forEach((field, index) => {
        if (field.labels?.length) return;
        const labelText = field.getAttribute('aria-label') || field.name;
        if (!labelText) return;
        if (!field.id) field.id = `FoField-${page || 'site'}-${index}`;
        const label = document.createElement('label');
        label.className = 'visually-hidden';
        label.htmlFor = field.id;
        label.textContent = labelText;
        field.before(label);
      });
    };

    ensureFormLabels();
    window.setTimeout(ensureFormLabels, 1200);

    const initializeNewsletter = () => {
      const signup = document.querySelector("[id$='__footer_m9NzUG'] .email-signup-block");
      const form = signup?.querySelector('.email-signup__form');

      if (!signup || !form || signup.classList.contains('fo-newsletter-ready')) return;

      const button = document.createElement('button');
      const icon = document.createElement('span');
      const formId = form.id || 'fo-footer-newsletter-form';

      form.id = formId;
      form.hidden = true;
      button.type = 'button';
      button.className = 'fo-newsletter-trigger';
      button.setAttribute('aria-controls', formId);
      button.setAttribute('aria-expanded', 'false');
      button.append(document.createTextNode('Unlock coupon code'));
      icon.className = 'fo-newsletter-trigger__icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.textContent = '+';
      button.append(icon);
      signup.prepend(button);
      signup.classList.add('fo-newsletter-ready');

      button.addEventListener('click', () => {
        const isOpen = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!isOpen));
        form.hidden = isOpen;
        if (!isOpen) form.querySelector('input[type="email"]')?.focus();
      });
    };

    initializeNewsletter();
    document.addEventListener('shopify:section:load', initializeNewsletter);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
